import { BoomGateArrowUpIcon } from './BoomGateArrowUpIcon';

/**
 * author: Michael Richins
 * id F9ADF5B2-435F-4820-8790-EAA72D6D5C75
 * name boom-gate-arrow-up
 * version: 3.7.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/boom-gate-arrow-up.svg
 * tags
 * - Transportation + Road 
 */
export const ArmBarrierUpIcon = BoomGateArrowUpIcon;
export default ArmBarrierUpIcon